/**
 * Returns the appropriate CSS class for a blog status
 * @param status The blog status (published, scheduled, draft, shared)
 * @returns CSS class string for the status badge
 */
export const getStatusColor = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'published':
      return 'bg-gray-100 text-gray-600';
    case 'scheduled':
      return 'bg-purple-100 text-purple-600';
    case 'draft':
      return 'bg-yellow-100 text-yellow-600';
    case 'shared':
      return 'bg-blue-100 text-blue-600';
    default:
      return 'bg-gray-100 text-gray-600';
  }
};
